export type GetIdConfig = {
    apiUrl: string;
    flowName: string;
    containerId: string;
    jwt: string;
    customerId?: string;
    injectCSSV7: string;
    mode?: 'inline' | 'popup';
    dictionary?: string;
    metadata?: Record<string, unknown>;
    locale?: string;
    profile?: GetIdProfileItem[];
    themeMode?: 'light' | 'dark';
    onComplete?: (param: { applicationId: string;}) => void;
    onFail?: (param: { code: string; message: string;}) => void;
    redirectUrl?: string;
};

export type GetIdProfileItem = {
    category: string;
    value: unknown;
    contentType?: 'string' | 'country' | 'date' | 'boolean';
};

export type GetIdServerConfig = Pick<GetIdConfig, 'metadata' | 'profile' | 'locale' | 'jwt'>;

export type GetIdWebSdkInstance = {
    changeThemeMode: (style: unknown) => void;
    unmount: () => void;
};

export type KycDetails = {
    daysToCompletion?: number;
    docs?: {
        docType: string;
        expires: string;
        status: KycDocStatus;
        type: string;
        uploadedDate: string;
    }[];
    status: KycStatus;
    hasDocumentInReview?: boolean;
    isStatusPending: boolean;
};

export const KycDocStatus = {
    Unknown: 'unknown',
    Verified: 'verified',
    Expired: 'expired',
    Failed: 'failed',
    NeedsReview: 'needs_review',
} as const;
export type KycDocStatus = typeof KycDocStatus[keyof typeof KycDocStatus];

export const KycStatus = {
    PartiallyVerified: 'partially_verified',
    Verified: 'verified',
    NotVerified: 'not_verified',
    Expired: 'expired',
    Failed: 'failed',
    NeedsReview: 'needs_review',
    Incomplete: 'incomplete',
} as const;
export type KycStatus = typeof KycStatus[keyof typeof KycStatus];
